// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"0ea993b6","815":"0fb3b67f"}[chunkId] + ".chunk.js";
};